<template>
    <div>
    <el-card class="allot_card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">公众号列表</span>
            <el-button style="float: right;" type="primary" @click="allotWeixinBox">确认分配</el-button>
        </div>
        <div>
            <el-table
            ref="itemSelect"
            v-loading="table_loading"
            element-loading-text="拼命加载中"
            :data="itemData"
            stripe
            border
            fit
            height="520"
            style="width: 100%"
            @selection-change="itemSelectionChange">
               <el-table-column
                    type="selection"
                    width="40">
                </el-table-column>
                <el-table-column
                    prop="code"
                    header-align="center"
                    min-width="80"
                    label="编号">
                </el-table-column>
                 <el-table-column
                    prop="title"
                    header-align="center"
                    min-width="120"
                    label="名称">
                </el-table-column>
                 <el-table-column
                    prop="appid"
                    header-align="center"
                    min-width="150"
                    label="APPID">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="220"
                    label="LOGO">
                    <template scope="scope">
                        <el-popover
                          ref="popoverPayStatus1"
                          placement="left-start"
                          trigger="hover">
                          <img  :src="scope.row.logo" style="width:140px;"/>
                        </el-popover>
                      <a v-popover:popoverPayStatus1 :href="scope.row.logo" target="_blank">{{scope.row.logo}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="220"
                    label="二维码">
                    <template scope="scope">
                        <el-popover
                          ref="popoverPayStatus1"
                          placement="right-start"
                          trigger="hover">
                          <img  :src="scope.row.qrCode" style="width:140px;"/>
                        </el-popover>
                        <a v-popover:popoverPayStatus1 :href="scope.row.qrCode" target="_blank">{{scope.row.qrCode}}</a>
                    </template>
                </el-table-column>
                 <el-table-column
                    prop="desc"
                    header-align="center"
                    min-width="150"
                    label="描述">
                </el-table-column>
            </el-table>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </div>
    </el-card>
    <div class="allotWeixinMask" v-if="allotDialogShow">
        <div class="box">
            <h3>提示</h3>
            <div class="content">
                <p>此操作将在选择的设备上分配选中的公众号, 是否继续?</p>
                <div>
                    <el-button @click="boxColose">取消</el-button>
                    <el-button @click="delItemCommit" type="primary">确认</el-button>
                </div>
            </div>
            <span @click="boxColose" 
            style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949">
                <i class="el-icon-close Danger"></i>
            </span>
        </div>
    </div>
</div>
</template>

<script>
    import $axios from '../../https/config'
    export default {
      props: ['deviceList'],
      data () {
        return {
          itemData: [],
          itemSelect: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          adResSelectList: [],
          allotDialogShow: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryItemDataList(this.pageNo, this.pageSize)
      },
      methods: {
        queryItemDataList (tPageNo, tPageSize) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize
          }
          this.table_loading = true
          this.itemData = []
          $axios.get('/device/getWeixinList', params, 'headers', function (res) {
            _this.table_loading = false
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    code: itemData.id,
                    title: itemData.name,
                    appid: itemData.appid,
                    logo: itemData.wx_logo,
                    qrCode: itemData.qrcode,
                    desc: itemData.description
                  }
                  resData.push(item)
                }
                _this.itemData = resData
              }
            } else {
            }
          }, function (err) {
            err
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryItemDataList(this.pageNo, this.pageSize, '')
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryItemDataList(this.pageNo, this.pageSize, '')
        },
        itemSelectionChange (val) {
          this.itemSelect = val
        },
        allotWeixinBox () {
          if (this.itemSelect.length > 0) {
            this.allotDialogShow = true
          } else {
            this.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要分配的公众号!'
            })
          }
        },
        delItemCommit () {
          var mDeviceList = []
          var mWxList = []
          for (var i = 0; i < this.deviceList.length; i++) {
            mDeviceList.push({
              deviceCode: this.deviceList[i].num
            })
          }
          for (var j = 0; j < this.itemSelect.length; j++) {
            mWxList.push({
              id: this.itemSelect[j].code
            })
          }
          this.allotWeixin(mDeviceList, mWxList)
        },
        allotWeixin (mDeviceList, mWxList) {
          this.loading = true
          var _this = this
          var params = {
            deviceList: mDeviceList,
            wxList: mWxList
          }
          $axios.post('/device/setDeviceWx', params, 'headers', function (res) {
            _this.loading = false
            _this.table_loading = false
            if (res && res.resultStatus === true) {
              _this.$message({
                type: 'success',
                duration: 1000 * 5,
                message: '分配广告成功!'
              })
              _this.closeAllotPicVideoDialog(true)
            } else {
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '分配广告失败!' + res.errorMessage
              })
              _this.boxColose(true)
            }
          })
        },
        boxColose () {
          this.allotDialogShow = false
        },
        closeAllotPicVideoDialog (tType) {
          this.allotDialogShow = false
          if (tType === true) {
            this.$emit('boxColose', tType)
          }
        }
      }
    }
</script>

<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }

     .allotWeixinMask {
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.3);
        z-index: 1001;
        
        .box {
            width: 400px;
            background: white;
            border-radius: 5px;
            box-shadow: 0 0 10px #666;
            top: 30%;
            left: 50%;
            margin-left: -200px;
            position: absolute;

            .el-button {
                width: 40%;
                margin: 4%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/allotWeixin.vue